"use client";

import { usePermissionsContext } from "~/app/providers";
import { HostApplicationType } from "@prisma/client";
import {
    DefaultUserValues,
    RSVPButtonControlData,
} from "~/components/rsvp/actions/rsvp-steps-and-data";
import EventRSVPControls from "~/components/v3/events-components/EventViewAndEdit/EventRSVPControls";
import ApplyToHostV2 from "~/components/v3/host/v2/ApplyToHostV2";
import { If } from "~/components/v3/Conditional";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { ProfileEditRequiredData } from "~/components/rsvp/validators";

import { RSVPButtonControl } from "./RSVPButtonControl";
import { refetchAction } from "./actions";
import { CustomizableLayout } from "~/types/CustomizableLayout";

export const RSVPWrapperClient = ({
    event,
    rsvpControlData,
    isFollowing,
    missingUserData,
    defaultUserValues,
    hasPaidForTicket,
    customization,
}: {
    event: EventBySlugOutput;
    rsvpControlData: RSVPButtonControlData;
    isFollowing: boolean;
    missingUserData: ProfileEditRequiredData | undefined;
    defaultUserValues: DefaultUserValues;
    hasPaidForTicket: boolean;
    customization?: CustomizableLayout;
}) => {
    const permissions = usePermissionsContext();
    const isApplyToHostAllowed = event.isApplyToHostAllowed;

    return (
        <EventRSVPControls
            event={event}
            refetch={() => refetchAction(event.slug)}
            isFollowing={isFollowing}
            rSVPButtonControl={
                <RSVPButtonControl
                    eventSlug={event.slug}
                    rsvpControlData={rsvpControlData}
                    missingUserData={missingUserData}
                    defaultUserValues={defaultUserValues}
                    refetchAction={async () => {
                        await refetchAction(event.slug);
                    }}
                    hasPaidForTicket={hasPaidForTicket}
                    customization={customization}
                />
            }
        >
            <If condition={isApplyToHostAllowed}>
                <ApplyToHostV2
                    isPreapprovedHost={permissions?.isPreapprovedHost}
                    type={HostApplicationType.EVENT}
                    event={event}
                    className="w-[calc(50%-0.5rem)] md:w-auto"
                    buttonClassName="w-full"
                    refetch={() => refetchAction(event.slug)}
                    customization={customization}
                />
            </If>
        </EventRSVPControls>
    );
};
